import React from 'react';
import useToggle from '../../hooks/useToggle';
export const withHover = (Component) => React.forwardRef((props, ref) => {
    const [isHovered, handleMouseEnter, handleMouseLeave] = useToggle();
    const withHoverProps = { isHovered, handleMouseEnter, handleMouseLeave };
    return React.createElement(Component, { ...withHoverProps, ...props, ref: ref });
});
export default withHover;
//# sourceMappingURL=index.js.map